import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, Modal, Text, TrackingNumber } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const AddTrackingNumberModal = ({ show, onClose, onAddTrackingNumber, loading }) => {
  const [trackingNumber, setTrackingNumber] = useState('')
  const [error, setError] = useState(false)

  const { t } = useTranslation()

  const handleChange = event => {
    const { error, value } = event

    setError(error)
    setTrackingNumber(value)
  }

  useEffect(() => {
    if (show) {
      setTrackingNumber('')
      setError(false)
    }
  }, [show])

  return (
    <Modal show={show} onClose={onClose} size="l" title={t('Número de seguimiento')}>
      <Styles.Container>
        <Text type="bodyMRegular">
          {t(
            'Añade un número de seguimiento para marcar la devolución como enviada y deshabilitar las notificaciones al cliente.'
          )}
        </Text>
        <TrackingNumber defaultValue={trackingNumber} onChange={handleChange} />
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            onClick={() => onAddTrackingNumber(trackingNumber)}
            loading={loading}
            disabled={loading || !trackingNumber || error}
            defaultLabel={t('Guardar')}
            loadingLabel={t('Guardando')}
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default AddTrackingNumberModal
